<div class="page-layout simple left-sidebar inner-sidebar inner-scroll h-screen">

    <!-- HEADER -->
    <div class="header accent p-6 flex items-center">
        <!-- <button
            class="sidebar-toggle mr-2 md:hidden"
            (click)="toggleSidebar('simple-left-sidebar-4')">
            <mat-icon>menu</mat-icon>
        </button> -->
        <div>
            <span class="text-4xl font-semibold">Administración de Clientes</span>
        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENIDO PRINCIPAL -->
    <div class="flex flex-1 overflow-hidden min-h-0">

        <!-- SIDEBAR -->
        <!--
        <fuse-sidebar class="sidebar" name="simple-left-sidebar-4" position="left" lockedOpen="gt-md">
        -->
        <div class="sidebar p-6 overflow-y-auto h-full">
            <entity-list
                #entityList
                title="Lista de clientes"
                [values]="clients"
                (entitySelected)="selected($event)">
            </entity-list>
        </div>
        <!-- / SIDEBAR -->

        <!-- DIVISOR -->
        <div class="w-px bg-gray-200"></div>

        <!-- CONTENIDO CENTRAL -->
        <div class="flex flex-col p-6 flex-1 overflow-y-auto">
            <!-- TÍTULO -->
            <span class="text-3xl font-semibold mb-4">Datos de cliente</span>

            <!-- BOTÓN NUEVO -->
            <div *ngIf="_systemService.canAction('adminClients')" class="pb-4 w-[600px] flex justify-end">
                <button (click)="newClient()" class="flex items-center gap-2 bg-blue-500 text-white py-2 px-4 rounded">
                    <mat-icon>add</mat-icon>
                    Nuevo
                </button>
            </div>

            <!-- FORMULARIO -->
            <div class="flex flex-col p-6 w-2/3 bg-white rounded-lg">
                <client-form #clientForm (entityChanged)="entityChanged($event)"></client-form>
            </div>

        </div>
        <!-- / CONTENIDO CENTRAL -->

    </div>
    <!-- / CONTENIDO PRINCIPAL -->

</div>
